import {Directive, ElementRef, EventEmitter, HostListener, Optional, Output} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
    selector: 'input'
})
export class TrimDirective {
    @Output() ngModelChange = new EventEmitter();

    constructor(private _el: ElementRef, @Optional() private control: NgControl) {
    }

    @HostListener('blur', ['$event']) onInputChange(event: any) {
        if (this._el.nativeElement.value) {
            this._el.nativeElement.value = this._el.nativeElement.value.trim();
        }

        if (!this.control?.control) {
            return;
        }

        // Return if it is matdatepicker
        if(!(this.control.control as any).nativeElement || (this.control.control as any).nativeElement?.classList.contains('mat-datepicker-input')) {
            return;
        }
        this.ngModelChange.emit(this._el.nativeElement.value)
        const errors = this.control.errors;
        this.control.control?.setValue(this._el.nativeElement.value);
        // Set Value will remove custom validation errors so set errors again
        if (errors) {
            this.control.control?.setErrors(errors);
        }

    }
}
